meedy.controller('meedy.popupVideoConsultationPatientCallingController', ['$rootScope', '$scope', '$state', '$mdDialog', '$mdToast', '$translate', '$timeout', 'meedy.objectHelper', 'details', 'meedy.videoConsultationModel', 'meedy.userModel', 'meedyConfig', 'meedy.termModel', 'meedy.patientModel', 'userModel',
  function ($rootScope, $scope, $state, $mdDialog, $mdToast, $translate, $timeout, objectHelper, details, videoConsultationModel, userModel, config, termModel, patientModel, edmUserModel) {

    function setData() {
      videoConsultationModel.details = undefined;
      $scope.details = details;

      $scope.title = document.title;
      $scope.timeout = null;
      $scope.blinking = true;

      $scope.cancelTimeout = null;

      $scope.inEdm = userModel.currentUser.inEdm;

      $scope.wasOpened = $('#video-popup').css('display') == 'block';
    }

    function setListeners() {

      if (videoConsultationModel.stompClient) {
        videoConsultationModel.stompClient.subscribe(config.SOCKET_URL.PREFIX + config.SOCKET_URL.CALL_ANSWERED + '-' + userModel.currentUser.id, function (greeting) {
          console.log("Received call answered " + greeting);
          // TODO rewrite this section, because now it cause problems when Doctor receives a call while opening the app
          //var inContainer = $("#video-popup").attr("order");
          //if (!$scope.wasOpened) {
          //  if (!inContainer || !(inContainer.indexOf(greeting.body) > -1)) {
          //    $mdDialog.cancel();
          //    $timeout.cancel($scope.cancelTimeout);
          //    $timeout.cancel($scope.timeout);
          //    document.title = $scope.title;
          //  }
          //} else {
          //  $scope.wasOpened = false;
          //}
        });

        $scope.$on(Event.MEEDY.TERM.GET_APPOINTMENT_BILLINGS.SUCCESS, function (event, offers) {
          $scope.offers = [];
          for (var i = 0; i < offers.length; i++) {
            $scope.offers.push(offers[i].idOffer);
          }
          termModel.begin($scope.details.idTerm);
        });

        $scope.$on(Event.MEEDY.TERM.BEGIN.SUCCESS, function (event, data) {
          var updateAppointmentWrapper = new UpdateAppointmentWrapperVO();
          updateAppointmentWrapper.appointmentBillingOffersIds = $scope.offers;

          termModel.executeAppointment($scope.details.idTerm, updateAppointmentWrapper);

          if ($scope.inEdm) {
            if (!data.patient.toBeVerified && edmUserModel.userHasRight(Constant.RIGHT.VISIT_CARD_MODULE_ACCESS)) {
              $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, {
                patientId: data.patient.id,
                visitId: data.id
              });
            } else {
              $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, {
                patientId: data.patient.id,
                visitId: data.id
              });
            }
          }

          $mdDialog.hide();
        });

        $scope.$on(Event.MEEDY.TERM.BEGIN.ERROR, function (event, data) {
          $mdDialog.hide();
        });


        $scope.$on(Event.MEEDY.TERM.EDM_VISIT.SUCCESS, function (event, edmVisit) {
          $scope.edmVisit = edmVisit;
          if (edmVisit && edmVisit.patient) {
            $scope.isVerified = !edmVisit.patient.toBeVerified;
          }
        });

        $scope.$on(Event.MEEDY.TERM.GET_TERM_DETAILS.SUCCESS, function (event, data) {
          $scope.term = data;
        });

      } else {
        $timeout(setListeners, 1000);
      }
    }

    function setActions() {

      $scope.closeWhenEnd = function () {
        var now = new Date();

        if ($scope.cancelTimeout) {
          $timeout.cancel($scope.cancelTimeout);
        }

        if (now.getTime() > $scope.details.endDate) {
          $mdDialog.cancel();
          $timeout.cancel($scope.cancelTimeout);
          $timeout.cancel($scope.timeout);
          document.title = $scope.title;

          $timeout(function () {
            $mdToast.simple({
              content: $translate.instant('T.MEEDY.MODULE.VIDEO_CONSULTATION.NOT_ANSWERED_FROM') + $scope.details.firstName + ' ' + $scope.details.lastName,
              hideDelay: 3000,
              position: 'top right',
              parent: $(".md-dialog-container")[0] != null ? $(".md-dialog-container")[0] : $("body")[0] //mdToast in popup bug
            }).theme('error');
          });
        } else {
          $scope.cancelTimeout = $timeout($scope.closeWhenEnd, 1000);
        }

      };

      $scope.startAppointment = function () {
        if ($scope.details.idTerm) {

          if (($scope.term.status == Enum.MEEDY.APPOINTMENT_STATUS.PRERESERVATION) || ($scope.term.status == Enum.MEEDY.APPOINTMENT_STATUS.RESERVATION)
            || ($scope.term.status == Enum.MEEDY.APPOINTMENT_STATUS.IN_PROGRESS) || !$scope.edmVisit) {
            $scope.beginingInProgress = true;
            termModel.getAppointmentBillings($scope.details.idTerm);
          } else {

            if ($scope.inEdm && $scope.edmVisit) {
              if ($scope.isVerified) {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, {
                  patientId: $scope.edmVisit.patient.id,
                  visitId: $scope.edmVisit.id
                });
              } else if ($scope.edmVisit && $scope.edmVisit.patient) {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, {
                  patientId: $scope.edmVisit.patient.id,
                  visitId: $scope.edmVisit.id
                });
              }
            }
            $mdDialog.hide();
          }
        }
      };

      $scope.answerCall = function () {
        console.log('Call answered');
        videoConsultationModel.details = details;
        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.START.SUCCESS);
        $scope.blinking = false;
        $timeout.cancel($scope.cancelTimeout);
        $timeout.cancel($scope.timeout);
        document.title = $scope.title;

        $("#video-popup").attr("order", $("#video-popup").attr("order") + ' ' + details.idOrder);

        var wrapper = new AckStatusWrapperVO();
        wrapper.portalIdOrder = details.idOrder;
        document.title = $scope.title;
        wrapper.status = Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS.ONLINE;
        videoConsultationModel.sendACKStatus(wrapper);
        $scope.startAppointment();
        if (!$scope.details.idTerm) {
          $mdDialog.hide();
        }
      };

      $scope.cancelCall = function () {
        var wrapper = new AckStatusWrapperVO();
        wrapper.portalIdOrder = details.idOrder;
        wrapper.status = Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS.REJECTED;
        videoConsultationModel.sendACKFreeStatus(wrapper);
        $scope.blinking = false;
        $timeout.cancel($scope.cancelTimeout);
        $timeout.cancel($scope.timeout);
        document.title = $scope.title;
        $mdDialog.cancel();
      };

      $scope.blinkTitle = function () {
        if ($scope.blinking) {
          document.title = document.title != $scope.title ? $scope.title : $translate.instant('T.MEEDY.MODULE.VIDEO_CONSULTATION.SOMEBODY_IS_CALLING', $scope.details);

          if ($scope.timeout) {
            $timeout.cancel($scope.timeout);
          }
          $scope.timeout = $timeout($scope.blinkTitle, 1000);
        } else {
          document.title = $scope.title;
        }
      }

    }

    function initialize() {
      var audio = new Audio('meedy/resource/asset/call.wav');
      audio.play();
      termModel.getTermDetails($scope.details.idTerm);
      termModel.edmVisit($scope.details.idTerm);
      $scope.blinkTitle();
      $scope.closeWhenEnd();
    }

    setData();
    setActions();
    setListeners();
    initialize();
  }
]);
